export default __webpack_public_path__ + "static/media/casa_timis_new.a4d56c79.png";